import React from "react"
import Plan from "./Plan"
import { connect } from "react-redux"
import numeral from "numeral"
import moment from "moment"
import { bindActionCreators } from "redux"
import { selectPlan } from "./actions"

const mapStateToProps = (state, ownProps) => {
  const user = state.models.user
  const { plan } = ownProps

  return {
    planName: plan.nickname || plan.interval + "ly",
    price: plan.amount / 100,
    billedAsLabel: `
      ${numeral(plan.amount / 100).format("$0,0[.]00")} billed
    ${plan.interval}ly`,

    displayPrice:
      plan.interval == "year" ? plan.amount / 100 / 12 : plan.amount / 100,
    interval: plan.interval,
    productIdentifier: plan.id,
    save: ["stripe.yearly.premium", "stripe.yearly.premium.trial"].includes(
      plan.id
    )
      ? "SAVE 37%"
      : null,
    isGroup: user.group_as_enterprise_owner,
    label: "/ user / " + plan.interval,
    buttonText: plan.trial_period_days
      ? `Start ${moment.duration(plan.trial_period_days, "day").humanize()} free
    trial`
      : plan.current_plan
        ? "Current Plan"
        : "Choose"
  }
}
const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({ onSelect: selectPlan }, dispatch)
  }
}
const ConnectedPlan = connect(
  mapStateToProps,
  mapDispatchToProps
)(Plan)

export default ConnectedPlan



// WEBPACK FOOTER //
// ./src/subscriptions/ConnectedPlan.js